module.exports = __webpack_public_path__ + "assets/oceanwp.b4c1f6b0.svg";